// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadTab_container__198pQ","dropzone":"UploadTab_dropzone__xn4yA"};